import React from 'react'

import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { CreateButton, useTranslate } from 'react-admin'

import { orange } from '../../constants/colorConstants'

export const advancedDefault = 1000
export const advancedNoInvoice = 1001
export const advancedPaidInvoices = 1002
export const delayedDefault = 2000
export const delayedNoInvoice = 2001
export const delayedNoDelayedNoLateInvoices = 2002
export const lateDefault = 3000
export const lateNoInvoice = 3001
export const lateNoDelayedLateInvoices = 3002
export const paidDefault = 4000
export const paidNoInvoice = 4001

const useStyles = makeStyles((theme) => ({
  message: {
    marginTop: '36px',
    marginBottom: '16px',
  },
  messageAlone: {
    marginTop: '36px',
    marginBottom: '36px',
  },
  button: {
    ...theme.mundi.font.roboto700Normal,
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: '16px',
    paddingBottom: '16px',
    borderRadius: '28px',
    border: `solid 1px ${orange}`,
    color: orange,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginBottom: '30px',
  },
}))

export const getAdvancedInvoiceType = (invoiceCount) => {
  const total = invoiceCount
    ? Object.keys(invoiceCount).reduce(
        (total, key) => total + invoiceCount[key],
        0
      )
    : 0
  if (!total) return advancedNoInvoice

  if (
    !invoiceCount['DELAYED'] &&
    !invoiceCount['LATE'] &&
    invoiceCount['PAID'] > 0
  )
    return advancedPaidInvoices

  return advancedDefault
}

export const getDelayedInvoiceType = (invoiceCount) => {
  const total = Object.keys(invoiceCount).reduce(
    (total, key) => total + invoiceCount[key],
    0
  )
  if (!total) return delayedNoInvoice

  if (!invoiceCount['LATE'] && total > 0) return delayedNoDelayedNoLateInvoices

  return delayedDefault
}

export const getLateInvoiceType = (invoiceCount) => {
  const total = Object.keys(invoiceCount).reduce(
    (total, key) => total + invoiceCount[key],
    0
  )
  if (!total) return lateNoInvoice

  if (!invoiceCount['DELAYED'] && total > 0) return lateNoDelayedLateInvoices

  return lateDefault
}

export const getPaidInvoiceType = (invoiceCount) => {
  const total = Object.keys(invoiceCount).reduce(
    (total, key) => total + invoiceCount[key],
    0
  )
  if (!total) return paidNoInvoice

  return paidDefault
}

export const AdvancedInvoicesEmpty = ({ invoiceCount }) => {
  const classes = useStyles()
  const translate = useTranslate()

  const mode = getAdvancedInvoiceType(invoiceCount)

  if (mode === advancedNoInvoice)
    return (
      <Box textAlign="center" m={1}>
        <Typography paragraph className={classes.message}>
          {translate('resources.invoices.empty.advanced.noInvoices.message')}
        </Typography>
        <CreateButton
          basePath="/invoices"
          className={classes.button}
          label={'resources.invoices.empty.advanced.noInvoices.button'}
          icon={<></>}
        ></CreateButton>
      </Box>
    )

  if (mode === advancedPaidInvoices)
    return (
      <Box textAlign="center" m={1}>
        <Typography paragraph className={classes.message}>
          {translate('resources.invoices.empty.advanced.paidInvoices.message')}
        </Typography>
        <CreateButton
          basePath="/invoices"
          className={classes.button}
          label={'resources.invoices.empty.advanced.paidInvoices.button'}
          icon={<></>}
        ></CreateButton>
      </Box>
    )

  return (
    <Box textAlign="center" m={1}>
      <Typography paragraph className={classes.message}>
        {translate(
          'resources.invoices.empty.advanced.delayedLateInvoices.message'
        )}
      </Typography>
      <CreateButton
        basePath="/invoices"
        className={classes.button}
        label={'resources.invoices.empty.advanced.delayedLateInvoices.button'}
        icon={<></>}
      ></CreateButton>
    </Box>
  )
}

export const DelayedInvoicesEmpty = ({ invoiceCount }) => {
  const classes = useStyles()
  const translate = useTranslate()

  const mode = getDelayedInvoiceType(invoiceCount)

  if (mode === delayedNoInvoice)
    return (
      <Box textAlign="center" m={1}>
        <Typography paragraph className={classes.message}>
          {translate('resources.invoices.empty.delayed.noInvoices.message')}
        </Typography>
        <CreateButton
          basePath="/invoices"
          className={classes.button}
          label={'resources.invoices.empty.delayed.noInvoices.button'}
          icon={<></>}
        ></CreateButton>
      </Box>
    )

  if (mode === delayedNoDelayedNoLateInvoices)
    return (
      <Box textAlign="center" m={1}>
        <Typography paragraph className={classes.messageAlone}>
          {translate(
            'resources.invoices.empty.delayed.noDelayedNoLateInvoices.message'
          )}
        </Typography>
      </Box>
    )

  return (
    <Box textAlign="center" m={1}>
      <Typography paragraph className={classes.messageAlone}>
        {translate(
          'resources.invoices.empty.delayed.noDelayedLateInvoices.message'
        )}
      </Typography>
    </Box>
  )
}

export const LateInvoicesEmpty = ({ invoiceCount }) => {
  const classes = useStyles()
  const translate = useTranslate()

  const mode = getLateInvoiceType(invoiceCount)

  if (mode === lateNoInvoice)
    return (
      <Box textAlign="center" m={1}>
        <Typography paragraph className={classes.message}>
          {translate('resources.invoices.empty.late.noInvoices.message')}
        </Typography>
        <CreateButton
          basePath="/invoices"
          className={classes.button}
          label={'resources.invoices.empty.late.noInvoices.button'}
          icon={<></>}
        ></CreateButton>
      </Box>
    )

  if (mode === lateNoDelayedLateInvoices)
    return (
      <Box textAlign="center" m={1}>
        <Typography paragraph className={classes.messageAlone}>
          {translate(
            'resources.invoices.empty.late.noDelayedLateInvoices.message'
          )}
        </Typography>
      </Box>
    )

  return (
    <Box textAlign="center" m={1}>
      <Typography paragraph className={classes.messageAlone}>
        {translate('resources.invoices.empty.late.noLateInvoices.message')}
      </Typography>
    </Box>
  )
}

export const PaidInvoicesEmpty = ({ invoiceCount }) => {
  const classes = useStyles()
  const translate = useTranslate()

  const mode = getPaidInvoiceType(invoiceCount)

  if (mode === paidNoInvoice)
    return (
      <Box textAlign="center" m={1}>
        <Typography paragraph className={classes.message}>
          {translate('resources.invoices.empty.paid.noInvoices.message')}
        </Typography>
        <CreateButton
          basePath="/invoices"
          className={classes.button}
          label={'resources.invoices.empty.paid.noInvoices.button'}
          icon={<></>}
        ></CreateButton>
      </Box>
    )

  return (
    <Box textAlign="center" m={1}>
      <Typography paragraph className={classes.messageAlone}>
        {translate('resources.invoices.empty.paid.noPaidInvoices.message')}
      </Typography>
    </Box>
  )
}
